module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links"
  }, [_c('ul', [_vm._l((_vm.links), function(item) {
    return [_c('li', {
      key: item.value,
      staticClass: "links-item",
      class: _vm.current === item.value && 'active',
      on: {
        "click": function($event) {
          return _vm.handleClick(item.value)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")])]
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1efa176c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1efa176c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_links/comps/distributor_tabs.vue
// module id = 2522
// module chunks = 0